import { makePath } from './routes';

export const getDefaultRoute = (workspaceId: string, tab?: string | null) => {
  const defaultTab = 'projects';
  return makePath(['w', workspaceId, ...(tab ?? defaultTab).split('/')]);
};
